module.exports = __webpack_public_path__ + "img/20191108154902422.b0ddcd29.jpg";